<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.menuName"
        placeholder="菜单名称"
        style="width: 200px;"
        class="filter-item"
        @keyup.enter.native="handleFilter"
      />
      <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
        搜索
      </el-button>
      <el-button
        class="filter-item"
        style="margin-left: 10px;"
        type="primary"
        icon="el-icon-edit"
        @click="handleCreate"
      >
        添加
      </el-button>
    </div>

    <el-table
      :key="tableKey"
      v-loading="listLoading"
      :data="filteredTreeData"
      border
      fit
      highlight-current-row
      row-key="id"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      :default-expand-all="expandAll"
      style="width: 100%;"
    >
      <el-table-column label="菜单名称" min-width="150" align="center">
        <template slot-scope="{row}">
          <span>{{ row.menuName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="菜单代码" width="150" align="center">
        <template slot-scope="{row}">
          <span>{{ row.menuCode }}</span>
        </template>
      </el-table-column>
      <el-table-column label="路径" width="200" align="center">
        <template slot-scope="{row}">
          <span>{{ row.path }}</span>
        </template>
      </el-table-column>
      <el-table-column label="权限标识" width="200" align="center">
        <template slot-scope="{row}">
          <span>{{ row.perms || row.permission || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="图标" width="100" align="center">
        <template slot-scope="{row}">
          <i :class="row.icon" />
        </template>
      </el-table-column>
      <el-table-column label="类型" width="100" align="center">
        <template slot-scope="{row}">
          <el-tag :type="menuTypeTagType(row.type)">
            {{ menuTypeLabel(row.type) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="排序" width="80" align="center">
        <template slot-scope="{row}">
          <span>{{ row.orderNum }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" class-name="status-col" width="100" align="center">
        <template slot-scope="{row}">
          <el-tag :type="row.status | statusFilter">
            {{ row.status === 1 ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="140" class-name="small-padding fixed-width">
        <template slot-scope="{row,$index}">
          <el-dropdown trigger="click" @command="command => handleAction(command, row, $index)">
            <el-button type="primary" size="mini">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="edit">编辑</el-dropdown-item>
              <el-dropdown-item command="addChild">新增</el-dropdown-item>
              <el-dropdown-item v-if="row.status === 0" command="enabled">启用</el-dropdown-item>
              <el-dropdown-item v-if="row.status === 1" command="disabled">禁用</el-dropdown-item>
              <el-dropdown-item divided command="delete">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" class="common-dialog">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="100px" class="common-dialog-form">
        <el-form-item label="菜单名称" prop="menuName">
          <el-input v-model="temp.menuName" placeholder="请输入菜单名称" />
        </el-form-item>
        <el-form-item label="菜单代码" prop="menuCode">
          <el-input v-model="temp.menuCode" placeholder="请输入菜单代码" />
        </el-form-item>
        <el-form-item v-if="temp.type !== 'C'" label="路径">
          <el-input v-model="temp.path" placeholder="目录/菜单路由路径" />
        </el-form-item>
        <el-form-item v-if="temp.type !== 'C'" label="组件">
          <el-input
            v-model="temp.component"
            :placeholder="temp.type === 'D' ? '目录请填 layout/index' : '请输入组件路径'"
          />
        </el-form-item>
        <el-form-item v-if="temp.type !== 'C'" label="图标">
          <el-input v-model="temp.icon" placeholder="请输入图标类名" />
        </el-form-item>
        <el-form-item label="上级菜单">
          <el-popover
            v-model="menuTreeVisible"
            placement="bottom-start"
            trigger="click"
            width="360"
            popper-class="menu-tree-popper"
          >
            <el-input
              v-model="menuTreeFilter"
              size="small"
              placeholder="请输入菜单名称"
              clearable
              class="menu-tree-filter"
            />
            <el-tree
              ref="menuTreeRef"
              :data="selectTreeData"
              :props="selectTreeProps"
              node-key="id"
              :expand-on-click-node="false"
              :highlight-current="true"
              :filter-node-method="filterMenuNode"
              empty-text="暂无数据"
              @node-click="handleMenuNodeClick"
            />
            <el-input
              slot="reference"
              :value="parentMenuLabel"
              placeholder="请选择上级菜单（不选为根菜单）"
              readonly
              clearable
              @clear="clearParentMenu"
            >
              <i slot="suffix" class="el-icon-arrow-down"></i>
            </el-input>
          </el-popover>
        </el-form-item>
        <el-form-item label="类型">
          <el-radio-group v-model="temp.type">
            <el-radio label="D">目录</el-radio>
            <el-radio label="M">菜单</el-radio>
            <el-radio label="C">按钮</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="temp.type === 'C'" label="权限标识" prop="perms">
          <el-input v-model="temp.perms" placeholder="如：system:user:create" />
        </el-form-item>
        <el-form-item label="排序" prop="orderNum">
          <el-input-number v-model="temp.orderNum" :min="0" :max="999" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="temp.status" class="filter-item" placeholder="请选择状态">
            <el-option v-for="item in statusOptions" :key="item.key" :label="item.display_name" :value="item.key" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()">
          确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMenuList, createMenu, updateMenu, deleteMenu } from '../../../api/menu'
import waves from '../../../directive/waves' // waves directive
import { parseTime } from '../../../utils/index'

export default {
  name: 'MenuTable',
  components: {},
  directives: { waves },
  filters: {
    parseTime,
    statusFilter(status) {
      const statusMap = {
        1: 'success',
        0: 'danger'
      }
      return statusMap[status]
    }
  },
  data() {
    const validatePerms = (rule, value, callback) => {
      if (this.temp.type === 'C' && !value) {
        callback(new Error('权限标识不能为空'))
      } else {
        callback()
      }
    }
    return {
      tableKey: 0,
      flatList: [],
      treeData: [],
      listLoading: true,
      listQuery: {
        menuName: undefined
      },
      statusOptions: [
        { key: 1, display_name: '启用' },
        { key: 0, display_name: '禁用' }
      ],
      menuTree: [],
      menuTreeVisible: false,
      menuTreeFilter: '',
      selectTreeProps: {
        children: 'children',
        label: 'displayName'
      },
      expandAll: true,
      temp: {
        id: undefined,
        menuName: '',
        menuCode: '',
        path: '',
        component: '',
        icon: '',
        perms: '',
        parentId: null,
        level: 1,
        orderNum: 0,
        type: 'M',
        status: 1
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑菜单',
        create: '创建菜单'
      },
      dialogPvVisible: false,
      pvData: [],
      rules: {
        menuName: [{ required: true, message: '菜单名称不能为空', trigger: 'blur' }],
        menuCode: [{ required: true, message: '菜单代码不能为空', trigger: 'blur' }],
        perms: [{ validator: validatePerms, trigger: 'blur' }]
      },
      downloadLoading: false
    }
  },
  created() {
    this.getList()
  },
  computed: {
    filteredTreeData() {
      const keyword = (this.listQuery.menuName || '').trim().toLowerCase()
      if (!keyword) {
        return this.treeData
      }
      return this.filterTree(this.treeData, keyword)
    },
    selectTreeData() {
      const currentId = this.temp && this.temp.id ? this.temp.id : null
      const markDisabled = (nodes) => nodes.map(node => ({
        ...node,
        disabled: currentId ? node.id === currentId : false,
        children: node.children ? markDisabled(node.children) : undefined
      }))
      return markDisabled(this.menuTree)
    },
    parentMenuLabel() {
      if (!this.temp || !this.temp.parentId) return ''
      const map = this.buildMenuMap(this.menuTree)
      return map[this.temp.parentId] || ''
    }
  },
  watch: {
    menuTreeFilter(value) {
      if (this.$refs.menuTreeRef) {
        this.$refs.menuTreeRef.filter(value)
      }
    },
    'temp.type'(value) {
      if (value !== 'C') {
        this.temp.perms = ''
      }
      if (value === 'D' && !(this.temp.component || '').trim()) {
        this.temp.component = 'layout/index'
      }
    }
  },
  methods: {
    menuTypeLabel(type) {
      const map = { D: '目录', M: '菜单', C: '按钮' }
      return map[type] || '菜单'
    },
    menuTypeTagType(type) {
      const map = { D: 'info', M: 'primary', C: 'success' }
      return map[type] || 'primary'
    },
    handleAction(command, row, index) {
      switch (command) {
        case 'edit':
          this.handleUpdate(row)
          break
        case 'addChild':
          this.handleCreateChild(row)
          break
        case 'enabled':
          this.handleModifyStatus(row, 'enabled')
          break
        case 'disabled':
          this.handleModifyStatus(row, 'disabled')
          break
        case 'delete':
          this.handleDelete(row, index)
          break
        default:
          break
      }
    },
    async getList() {
      this.listLoading = true
      try {
        const list = await this.fetchAllMenus(this.listQuery.menuName)
        this.flatList = list
        this.treeData = this.buildTree(list)
        this.menuTree = this.treeData
      } finally {
        this.listLoading = false
      }
    },
    async fetchAllMenus(menuName, page = 0, size = 1000, acc = []) {
      const data = {
        page,
        size
      }
      if (menuName) {
        data.menuName = menuName
      }
      const response = await getMenuList(data)
      const content = (response.data && response.data.content) ? response.data.content : []
      const totalPages = response.data && response.data.totalPages !== undefined
        ? response.data.totalPages
        : 1
      const nextAcc = acc.concat(content)
      if (page + 1 < totalPages) {
        return this.fetchAllMenus(menuName, page + 1, size, nextAcc)
      }
      return nextAcc
    },
    async getMenuOptions() {
      const list = await this.fetchAllMenus()
      this.menuTree = this.buildTree(list)
    },
    buildMenuMap(nodes, map = {}) {
      for (const node of nodes) {
        map[node.id] = node.menuName
        if (node.children && node.children.length > 0) {
          this.buildMenuMap(node.children, map)
        }
      }
      return map
    },
    buildTree(list, parentId = null) {
      const nodes = list
        .filter(item => item.parentId === parentId)
        .map(item => ({ ...item }))
        .sort((a, b) => {
          const ao = a.orderNum
          const bo = b.orderNum
          const aHas = ao !== null && ao !== undefined
          const bHas = bo !== null && bo !== undefined
          if (aHas && bHas && ao !== bo) return ao - bo
          if (aHas !== bHas) return aHas ? -1 : 1
          return (a.id || 0) - (b.id || 0)
        })

      for (const node of nodes) {
        const children = this.buildTree(list, node.id)
          if (children.length > 0) {
            node.children = children
          }
        const count = node.children ? node.children.length : 0
        node.displayName = count > 0 ? `${node.menuName} (${count})` : node.menuName
      }
      return nodes
    },
    filterMenuNode(value, data) {
      if (!value) return true
      return (data.menuName || '').toLowerCase().includes(value.toLowerCase())
    },
    handleMenuNodeClick(node) {
      if (node.disabled) return
      this.temp.parentId = node.id
      this.menuTreeVisible = false
    },
    clearParentMenu() {
      this.temp.parentId = null
    },
    filterTree(tree, keyword) {
      const result = []
      for (const node of tree) {
        const match = (node.menuName || '').toLowerCase().includes(keyword)
        let children = []
        if (node.children && node.children.length > 0) {
          children = this.filterTree(node.children, keyword)
        }
        if (match || children.length > 0) {
          result.push({
            ...node,
            children: match ? node.children : children
          })
        }
      }
      return result
    },
    handleFilter() {
      this.getList()
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        menuName: '',
        menuCode: '',
        path: '',
        component: '',
        icon: '',
        perms: '',
        parentId: null,
        level: 1,
        orderNum: 0,
        type: 'M',
        status: 1
      }
    },
    async handleCreate() {
      await this.getMenuOptions()
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    async handleCreateChild(row) {
      await this.getMenuOptions()
      this.resetTemp()
      this.temp.parentId = row.id
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          // 设置层级
          if (this.temp.parentId) {
            this.temp.level = 2 // 简单示例，实际应根据父节点层级计算
          } else {
            this.temp.level = 1
          }
          
          createMenu(this.temp).then(() => {
            this.getList()
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000
            })
          })
        }
      })
    },
    async handleUpdate(row) {
      await this.getMenuOptions()
      this.temp = Object.assign({}, row) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.temp)
          updateMenu(tempData).then(() => {
            this.getList()
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
          })
        }
      })
    },
    handleModifyStatus(row, status) {
      const statusText = status === 'enabled' ? '启用' : '禁用'
      const newStatus = status === 'enabled' ? 1 : 0
      this.$confirm(`此操作将${statusText}该菜单, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const tempData = Object.assign({}, row)
        tempData.status = newStatus
        updateMenu(tempData).then(() => {
          this.getList()
          this.$notify({
            title: '成功',
            message: `${statusText}成功`,
            type: 'success',
            duration: 2000
          })
        })
      })
    },
    handleDelete(row, index) {
      this.$confirm('此操作将永久删除该菜单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteMenu(row.id).then(() => {
          this.getList()
          this.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success',
            duration: 2000
          })
        })
      })
    }
  }
}
</script>